import { Injectable } from '@angular/core';
import { NotificationActionApiModel } from '@app/api/api-models/notifications/NotificationActionApiModel';
import { NotificationActionType } from '../enums/notification-action-type.enum';
import { RouteHelperService } from './route-helper.service';
import { StartQuizService } from './start-quiz.service';

@Injectable()
export class NotificationActionService {
  constructor(private readonly routeHelper: RouteHelperService, private readonly startQuizService: StartQuizService) {}

  public perform(action: NotificationActionApiModel): void {
    switch (action.NotificationActionType) {
      case NotificationActionType.CreateFtForm:
        this.performOpenDashboard(action);
        break;
      case NotificationActionType.CreatePeForm:
        this.performOpenDashboard(action);
        break;
      case NotificationActionType.CreatePpForm:
        this.performOpenDashboard(action);
        break;
      case NotificationActionType.ProcessFtFormStep:
        this.performProcessStep(action);
        break;
      case NotificationActionType.OpenDashboard:
        this.performOpenDashboard(action);
        break;
      case NotificationActionType.FollowLink:
        this.performFollowLink(action);
        break;
      case NotificationActionType.TakeQuiz:
        this.performTakeQuiz(action);
        break;
      case NotificationActionType.ProcessQuizStep:
        this.performProcessQuizStep(action);
        break;
      case NotificationActionType.ProcessPeFormStep:
        this.performProcessPeFormStep(action);
        break;
      case NotificationActionType.ProcessPpFormStep:
        this.performProcessPpFormStep(action);
        break;
      case NotificationActionType.LateQuizOpenDashboard:
        this.performOpenDashboard(action);
        break;
      case NotificationActionType.OpenFtFormInstance:
        this.performOpenFormInstance(action);
        break;
      case NotificationActionType.OpenPeFormInstance:
        this.performOpenFormInstance(action);
        break;
      case NotificationActionType.OpenPpFormInstance:
        this.performOpenFormInstance(action);
        break;
      case NotificationActionType.OpenTrainingCourseClass:
        this.performOpenTrainingCourseClass(action);
        break;
      default:
        throw new Error(`Error: Unsupported ActionType: ${action.NotificationActionType}.`);
    }
  }

  private performFollowLink(action: NotificationActionApiModel): void {
    const slashIndex = action.Link.lastIndexOf('/');
    const id = action.Link.substring(slashIndex + 1);
    this.routeHelper.downloadExport(id);
  }

  private performProcessStep(action: NotificationActionApiModel): void {
    this.routeHelper.formInstance(action.TargetFormInstanceId);
  }

  private performOpenDashboard(action: NotificationActionApiModel): void {
    this.routeHelper.dashboard(action.TargetProgramRoleId);
  }

  private performTakeQuiz(action: NotificationActionApiModel): void {
    this.startQuizService.start(action.TargetQuizInstanceId);
  }

  private performProcessQuizStep(action: NotificationActionApiModel): void {
    this.routeHelper.quizInstance(action.TargetQuizInstanceId);
  }

  private performProcessPeFormStep(action: NotificationActionApiModel): void {
    this.routeHelper.formInstance(action.TargetFormInstanceId);
  }

  private performProcessPpFormStep(action: NotificationActionApiModel): void {
    this.routeHelper.formInstance(action.TargetFormInstanceId);
  }

  private performOpenFormInstance(action: NotificationActionApiModel): void {
    this.routeHelper.formInstance(action.TargetFormInstanceId);
  }

  private performOpenTrainingCourseClass(action: NotificationActionApiModel): void {
    this.routeHelper.trainingCourseClass(action.TargetTrainingCourseClassId);
  }
}
